<template>
  <div>
    <div
      id="service-review-table"
      v-for="(city, i) in merged"
      :key="i"
      class="data-table"
    >
      <div class="header">
        <div>City</div>
        <div>Skill</div>
        <div>Started</div>
        <div>Waiting</div>
        <div>Disabled</div>
        <div>Verified</div>
        <div>Rate min</div>
        <div>Rate max</div>
        <div>Rate average</div>
      </div>
      <div
        v-for="skill in city.skills"
        :key="city.city + '-' + skill.id"
        class="row"
      >
        <div class="cell">{{ city.city }}</div>
        <div class="cell">
          {{
            skill.localizedTitle.lt
          }}<span class="subtext">{{ skill.id }}</span>
        </div>
        <div class="cell" @click="openModal(skill.startedDetails)">
          {{ skill.started }}
        </div>
        <div class="cell" @click="openModal(skill.waitingDetails)">
          {{ skill.waiting }}
        </div>
        <div class="cell" @click="openModal(skill.disabledDetails)">
          {{ skill.disabled }}
        </div>
        <div class="cell" @click="openModal(skill.verifiedDetails)">
          {{ skill.verified }}
        </div>
        <div class="cell">
          {{ skill.min !== 999999 ? (skill.min / 100).toFixed(2) : 0.0 }}
        </div>
        <div class="cell">{{ (skill.max / 100).toFixed(2) }}</div>
        <div class="cell">{{ (skill.average / 100).toFixed(2) }}</div>
      </div>
      <div class="modal" v-if="isOpen">
        <a @click="closeModal">CLOSE</a>
        <div>
          <ul>
            <li v-for="(item, k) in detailList" :key="k">
              <router-link
                :to="{ name: 'userProfile', params: { id: item } }"
                >{{ item }}</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
#service-review-table {
  grid-template-columns: auto auto auto auto auto auto auto auto auto;
}
.subtext {
  display: block;
  color: #666;
  font-size: 80%;
  height: 0;
}
.cell {
  padding-top: 20px;
  padding-bottom: 20px;
}
.modal {
  position: fixed;
  top: calc(50% - 150px);
  left: calc(50% - 200px);
  width: 400px;
  height: 300px;
  background-color: #fff;
  padding: 30px;
  border: 1px solid #444;
  overflow-y: scroll;
}
</style>

<script>
// import * as storeReader from "../services/storeReader";
import api from "../services/api";
import _ from "lodash";

export default {
  data: function () {
    return {
      pros: [],
      merged: [],
      grouped: [],
      skills: [],
      detailList: [],
      isOpen: false,
      cities: [
        {
          code: "vilnius",
          name: "Vilnius",
          currency: "EUR",
          location: { lat: 54.687157, lng: 25.279652 },
        },
        {
          code: "kaunas",
          name: "Kaunas",
          currency: "EUR",
          location: { lat: 54.898521, lng: 23.903597 },
        },
        {
          code: "klaipeda",
          name: "Klaipėda",
          currency: "EUR",
          location: { lat: 55.703297, lng: 21.144279 },
        },
        {
          code: "warsaw",
          name: "Warszawa",
          currency: "PLN",
          location: { lat: 52.237049, lng: 21.017532 },
        },
      ],
    };
  },
  methods: {
    openModal: function (details) {
      this.detailList = details;
      this.isOpen = true;
    },
    closeModal: function () {
      this.isOpen = false;
    },
    getDistanceFromLatLonInKm: function (lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the earth in km
      const dLat = this.deg2rad(lat2 - lat1); // deg2rad below
      const dLon = this.deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c; // Distance in km
      // console.log('Distance between', lat1, lon1, lat2, lon2, 'is', d);
      return d;
    },
    deg2rad: function (deg) {
      return deg * (Math.PI / 180);
    },
    getData: async function () {
      const cities = this.cities;
      const skills = Object.values(this.$store.state.skills).map((skill) => {
        return {
          ...skill,
          started: 0,
          startedDetails: [],
          waiting: 0,
          waitingDetails: [],
          disabled: 0,
          disabledDetails: [],
          verified: 0,
          verifiedDetails: [],
          min: 999999,
          max: 0,
          sum: 0,
          average: 0,
        };
      });

      const arr = [];
      cities.forEach((city) => {
        arr.push({ skills, city: city.code });
      });

      // force cloning the object
      const skillsWithCities = JSON.parse(JSON.stringify(arr));

      const pros = await api.getProsStartedVerification();

      pros.forEach((pro) => {
        // if pro entered the service area, iterate over cities
        if (pro.serviceArea) {
          cities.forEach((city) => {
            const distance = this.getDistanceFromLatLonInKm(
              pro.serviceArea.latitude,
              pro.serviceArea.longitude,
              city.location.lat,
              city.location.lng
            );

            // if service area covers the city, iterate over skills
            if (distance <= pro.serviceArea.radius / 1000 && pro.skills) {
              pro.skills.forEach((skill) => {
                const cityIndex = skillsWithCities.findIndex(
                  (el) => el.city === city.code
                );
                const skillIndex = skillsWithCities[cityIndex].skills.findIndex(
                  (el) => el.id === skill
                );

                if (cityIndex >= 0 && skillIndex >= 0) {
                  const current = _.cloneDeep(
                    skillsWithCities[cityIndex].skills[skillIndex]
                  );

                  if (pro.id === "5073f341-d60b-42fe-8036-87393d8c7eb2") {
                    console.log(
                      pro,
                      cityIndex,
                      skillIndex,
                      current,
                      skillsWithCities
                    );
                  }
                  // if pro is fully verified calculate all the rates
                  if (pro.verified) {
                    skillsWithCities[cityIndex].skills[skillIndex] = {
                      ...current,
                      verified: current.verified + 1,
                      min:
                        current.min > pro.skillSettings[skill].rate
                          ? pro.skillSettings[skill].rate
                          : current.min,
                      max:
                        current.max < pro.skillSettings[skill].rate
                          ? pro.skillSettings[skill].rate
                          : current.max,
                      sum: current.sum + pro.skillSettings[skill].rate,
                      average:
                        (current.sum + pro.skillSettings[skill].rate) /
                        (current.verified + 1),
                    };
                    skillsWithCities[cityIndex].skills[
                      skillIndex
                    ].verifiedDetails.push(pro.id);
                  } else if (pro.awaitingVerification) {
                    skillsWithCities[cityIndex].skills[skillIndex].waiting =
                      current.waiting + 1;
                    skillsWithCities[cityIndex].skills[
                      skillIndex
                    ].waitingDetails.push(pro.id);
                  } else {
                    skillsWithCities[cityIndex].skills[skillIndex].started =
                      current.started + 1;
                    skillsWithCities[cityIndex].skills[
                      skillIndex
                    ].startedDetails.push(pro.id);
                  }

                  if (pro.ordersDisabled) {
                    skillsWithCities[cityIndex].skills[skillIndex].disabled =
                      current.disabled + 1;
                    skillsWithCities[cityIndex].skills[
                      skillIndex
                    ].disabledDetails.push(pro.id);
                  }
                }
              });
            }
          });
        }
      });
      this.merged = skillsWithCities;
      console.log(skillsWithCities);
    },
  },
  created: async function () {
    await this.getData();
  },
};
</script>